import api from 'config/api';
import { APIError } from 'error/APIError';
import { ApiResponse, AuthenticationPayload } from '@mrp-system/common';

export const loginUser = async ({
  email,
  password,
  remember,
}: {
  email: string;
  password: string;
  remember: boolean;
}) => {
  const { data, headers } = await api.post<ApiResponse<AuthenticationPayload>>(
    '/user/login',
    {
      email,
      password,
      remember,
    }
  );

  if (data.status === 'SUCCESS' || data.status === 'WARNING') {
    return data;
  } else {
    throw new APIError(data.message, data, headers);
  }
};
